module.exports = __webpack_public_path__ + "images/icon_sound_off_8499fd6d7261c3dbdf705b86c45e38ab.svg";